module.exports = __webpack_public_path__ + "img/18.715204aa.jpg";